import { Color, Kind, ModalWindow } from '@usitsdasdesign/dds-react';
import { yupValidator } from 'lib/yup-validator';
import RenderFields from 'molecules/RenderFields';
import moment from 'moment';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { getWorkingHoursPerWeek, getMaxWorkingHoursPerWeek } from 'services/allocation.service';
import { useState, useEffect } from 'react';
import Drawer from './Drawer';
import ButtonGroup from './ButtonGroup';
import AddShiftDrawer from '@/components/AddShiftDrawer';

function MultiChangeSchedule({
    show = false,
    onClose,
    onSave,
    title = 'Schedule Change for Multiple Employees',
    saveLabel = 'Save',
    startDateLabel = 'Start date'
}) {
    if (!show) return null;

    const [hrsPerWeekUpperLimit, setHrsPerWeekUpperLimit] = useState(getWorkingHoursPerWeek());
    const [maxHoursPerWeek, setMaxHoursPerWeek] = useState(getMaxWorkingHoursPerWeek());
    const [showShiftModal, setShowShiftModal] = useState(false)

    const testAllocationHour = (val, watch) => {
        if (!val && val !== 0) return true;
        const weekendInclude = watch('include');
        let includeSat; let includeSun;
        if (weekendInclude) {
            includeSat = weekendInclude[0].value;
            includeSun = weekendInclude[1].value;
        }
        const hoursPerWeekValue = getWorkingHoursPerWeek(
            { includeSunday: includeSun, includeSaturday: includeSat }
        );

        const maxHoursPerWeek = getMaxWorkingHoursPerWeek({ includeSaturday: includeSat, includeSunday: includeSun });
        setMaxHoursPerWeek(maxHoursPerWeek);
        setHrsPerWeekUpperLimit(hoursPerWeekValue);

        return val <= maxHoursPerWeek;
    };

    const {
        register,
        handleSubmit,
        control,
        setValue,
        watch,
        trigger,
        formState: { errors, isValid }
    } = useForm({
        mode: 'onChange',
        resolver: yupValidator(
            yup.object().shape({
                startDate: yup.string().nullable(),
                endDate: yup.string().nullable()
                .test(
                  'end-date-check',
                  'End date should be equal or after the start date',
                  function (val) {
                    const { startDate } = this.parent;
                    if (!startDate || !val) return true; 
                    const endDate = moment(val).startOf('day');
                    const start = moment(startDate).startOf('day');
                    return endDate.isSameOrAfter(start);
                  }
                ),
                hoursPerWeek: yup.string().nullable()
                    .test(
                        'value',
                        'Hours/Week should be greater than 0',
                        (val) => {
                            if (val === '' || typeof val === 'undefined') return true
                            return val > 0
                        }
                    )
                    .test(
                        'value',
                        `Hours/Week should not be greater than
                          ${maxHoursPerWeek}`,
                        (val) => testAllocationHour(val, watch)
                    ),
                include: yup.array(),
            })
        )

    });

    useEffect(() => {
        if (watch('hoursPerWeek') || watch('include')) {
            trigger();
        }
    }, [watch('hoursPerWeek'), watch('include'), hrsPerWeekUpperLimit]);

    const fields = [
        {
            id: 1,
            type: 'calendor',
            name: 'startDate',
            label: startDateLabel,
            // isRequired: true,
            size: 'l'
        },
        {
            id: 2,
            type: 'calendor',
            name: 'endDate',
            label: 'End date',
            // isRequired: true,
            size: 'l',
            // isDisabled: watch('startDate') === undefined,
            // disabledDates: {
            //     // before: watch('startDate')
            // }
        },
        {
            id: 3,
            type: 'text-input',
            name: 'hoursPerWeek',
            label: 'Hours/week',
            placeholder: 'Enter Hours',
            // isRequired: true
        },
        {
            id: 10,
            type: 'checkbox-group',
            groupTitle: 'Include',
            name: 'include',
            direction: 'row',
            checkboxItems: [
                {
                    value: watch('include') ? watch('include')[0].value : false,
                    label: 'Saturday'
                },
                {
                    value: watch('include') ? watch('include')[1].value : false,
                    label: 'Sunday'
                }
            ]
        }
    ];
    
    return (
        <>
            <ModalWindow
                title={title}
                mobile={true}
                requiredTitle={false}
                show={true}
                onClose={onClose}    
                className='modal-window lg'
                actions={[
                    {
                        title: 'Close',
                        kind: Kind.secondaryLoud,
                        color: Color.green,
                        isDisabled: false,
                        onClick: onClose
                    },
                    {
                        title: saveLabel,
                        kind: Kind.primaryLoud,
                        color: Color.green,
                        isDisabled: !!Object.keys(errors).length,
                        onClick: () => {
                            handleSubmit(onSave)();
                        }
                    }
                ]}
            >
                <RenderFields
                    fields={fields}
                    control={control}
                    register={register}
                    errors={errors}
                    setValue={setValue}
                    watch={watch}
                    useMinDate={false}
                />
            </ModalWindow>
            <AddShiftDrawer showAddShiftDrawer={showShiftModal} startDate={watch('startDate')} endDate={watch('endDate')}  onHideAddShiftDrawer={()=>{setShowShiftModal(false)}} />

        </>
    );
}

export default MultiChangeSchedule;
